import { DesktopRow, FooterContainer, Link, MobileRow } from "./Footer.styles";
import { useNavigate } from "react-router-dom";

const SUPPORT_EMAIL = "support@playbun.com";
const TELEGRAM_URL = "https://t.me/Playboxvip";

const TOP_ROW = [
  { label: "Support", action: "email", title: "Contact Support via Email" },
  { label: "Submit a Request", path: "submit-a-request" },
];

const BOTTOM_ROW = [
  { label: "Privacy Policy", path: "privacy-policy" },
  { label: "Terms of Use", path: "terms-and-conditions" },
  {
    label: "Telegram",
    action: "telegram",
    title: "Giveaways and Announcements",
  },
  {
    label: "Content removal",
    path: "request-removal-of-content",
  },
];

const FOOTER_LINKS = [
  { label: "Support", action: "email", title: "Contact Support via Email" },
  { label: "Submit a Request", path: "submit-a-request" },
  { label: "Privacy Policy", path: "privacy-policy" },
  { label: "Terms of Use", path: "terms-and-conditions" },

  {
    label: "Telegram",
    action: "telegram",
    title: "Giveaways and Announcements",
  },
  {
    label: "Content removal",
    path: "request-removal-of-content",
  },
];

const Footer = () => {
  const navigate = useNavigate();

  const handleClick = (link) => {
    if (link.action === "email") {
      const subject = encodeURIComponent("Support Request - Playbun.com");
      const body = encodeURIComponent(
        "Hello Support Team,\n\nI am experiencing the following issue:\n\n[Please describe your problem here]\n\nThank you,\n[Your Name]",
      );
      window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
    } else if (link.action === "telegram") {
      window.open(TELEGRAM_URL, "_blank");
    } else {
      navigate(`/${link.path}`);
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  };

  const renderLinks = (links) =>
    links.map((link) => (
      <Link
        key={link.label}
        onClick={() => handleClick(link)}
        title={link.title}
      >
        {link.label}
      </Link>
    ));

  return (
    <FooterContainer>
      <MobileRow>{renderLinks(TOP_ROW)}</MobileRow>
      <MobileRow>{renderLinks(BOTTOM_ROW)}</MobileRow>
      <DesktopRow>{renderLinks(FOOTER_LINKS)}</DesktopRow>
    </FooterContainer>
  );
};

export default Footer;
